/* eslint-disable */
// 身份证本地校验
// 18位身份证校验省份、生日、校验码
// 15位身份证校验省份、生日
export const CheckIdCardClass = {
  // Wi 加权因子 Xi 余数0~10对应的校验码 Pi省份代码
  Wi: [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
  Xi: [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2],
  Pi: [11, 12, 13, 14, 15, 21, 22, 23, 31, 32, 33, 34, 35, 36, 37, 41, 42, 43, 44, 45, 46, 50, 51, 52, 53, 54, 61, 62, 63, 64, 65, 71, 81, 82, 91],

  // 检验18位身份证号码出生日期是否有效
  // parseFloat过滤前导零，年份必需大于等于1900且小于等于当前年份，用Date()对象判断日期是否有效。
  brithday18(sIdCard) {
    const year = parseFloat(sIdCard.substr(6, 4));
    const month = parseFloat(sIdCard.substr(10, 2));
    const day = parseFloat(sIdCard.substr(12, 2));
    const checkDay = new Date(year, month - 1, day);
    const nowDay = new Date();
    if (year >= 1900 && year <= nowDay.getFullYear() && month == (checkDay.getMonth() + 1) && day == checkDay.getDate()) {
      return true;
    }
    return false;
  },

  // 检验15位身份证号码出生日期是否有效
  brithday15(sIdCard) {
    const year = parseFloat(sIdCard.substr(6, 2));
    const month = parseFloat(sIdCard.substr(8, 2));
    const day = parseFloat(sIdCard.substr(10, 2));
    const checkDay = new Date(year, month - 1, day);
    if (month == (checkDay.getMonth() + 1) && day == checkDay.getDate()) {
      return true;
    }
    return false;
  },

  // 检验校验码是否有效
  validate(sIdCard) {
    const aIdCard = sIdCard.split('');
    let sum = 0;
    for (let i = 0; i < CheckIdCardClass.Wi.length; i++) {
      sum += CheckIdCardClass.Wi[i] * aIdCard[i]; // 线性加权求和
    }
    const index = sum % 11; // 求模，可能为0~10,可求对应的校验码是否于身份证的校验码匹配
    if (CheckIdCardClass.Xi[index] == aIdCard[17].toUpperCase()) {
      return true;
    }
    return false;
  },

  // 检验输入的省份编码是否有效
  province(sIdCard) {
    const p2 = sIdCard.substr(0, 2);
    for (let i = 0; i < CheckIdCardClass.Pi.length; i++) {
      if (CheckIdCardClass.Pi[i] == p2) {
        return true;
      }
    }
    return false;
  },

  // 校验身份证
  checkIdCard(idCard) {
    if (!idCard) return;
    if (idCard.length === 18) {
      return this.province(idCard) && this.brithday18(idCard) && this.validate(idCard);
    } else if (idCard.length === 15) {
      return this.province(idCard) && this.brithday15(idCard);
    }
  },
};



// WEBPACK FOOTER //
// ./src/libs/credential-validate.js